import { render, staticRenderFns } from "./CommentActionButtons.vue?vue&type=template&id=4a8c29f0"
import script from "./CommentActionButtons.vue?vue&type=script&lang=js"
export * from "./CommentActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports